import { useTranslation } from "react-i18next";
import i18n from '@/../i18n'
import { SpecialField, SpecialFieldGroup } from "@/services/hooks/useEmailTemplateSpecialFields/types";
import { getSpecialFieldWithFreeValueRegex } from "../tools/getSpecialFieldWithFreeValueRegex";
import { ADDITIONAL_VALUE_LENGTH, REGEX_CUSTOM_VALUE, REGEX_URL } from "../constants";

// eslint-disable-next-line max-lines-per-function
export const useStaticEmailSpecialFields = (): SpecialField[] => {
    const { t } = useTranslation();
    return [
        /* DISABLED TILL BACKEND FIX:
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.CONTACT,
            name: 'consent tracking',
            regexKeyword: 'consenttracking',
        }),
        */
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.CONTACT,
            id: 'email',
            name: 'email',
            regexKeyword: 'email'
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.CONTACT,
            id: 'first name',
            name: 'first name',
            regexKeyword: 'firstname'
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.CONTACT,
            id: 'last name',
            name: 'last name',
            regexKeyword: 'lastname'
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.CONTACT,
            id: 'recipient',
            name: 'recipient',
            regexKeyword: 'recipient'
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.ACCOUNT_PROFILE,
            id: 'account address',
            name: 'account address',
            regexKeyword: 'accountaddress',
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.ACCOUNT_PROFILE,
            id: 'account address 1',
            name: 'account address 1',
            regexKeyword: 'accountaddress1',
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.ACCOUNT_PROFILE,
            id: 'account address 2',
            name: 'account address 2',
            regexKeyword: 'accountaddress2',
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.ACCOUNT_PROFILE,
            id: 'account city',
            name: 'account city',
            regexKeyword: 'accountcity',
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.ACCOUNT_PROFILE,
            id: 'account country',
            name: 'account country',
            regexKeyword: 'accountcountry',
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.ACCOUNT_PROFILE,
            id: 'account company',
            name: 'account company',
            regexKeyword: 'accountcompany',
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.ACCOUNT_PROFILE,
            id: 'account email',
            name: 'account email',
            regexKeyword: 'accountemail',
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.ACCOUNT_PROFILE,
            id: 'account first name',
            name: 'account first name',
            regexKeyword: 'accountfirstname',
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.ACCOUNT_PROFILE,
            id: 'account last name',
            name: 'account last name',
            regexKeyword: 'accountlastname',
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.ACCOUNT_PROFILE,
            id: 'account phone',
            name: 'account phone',
            regexKeyword: 'accountphone',
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.ACCOUNT_PROFILE,
            id: 'account state',
            name: 'account state',
            regexKeyword: 'accountstate',
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.ACCOUNT_PROFILE,
            id: 'account website',
            name: 'account website',
            regexKeyword: 'accountwebsite',
        }),
        getSpecialFieldWithFreeValueRegex({
            group: SpecialFieldGroup.ACCOUNT_PROFILE,
            id: 'account zip',
            name: 'account zip',
            regexKeyword: 'accountzip',
        }),

        // SHOULD BE DISABLED IN CHECKOUT EMAIL, use disableByName = ['url']
        {
            group: SpecialFieldGroup.GENERAL,
            displayName: 'Activation URL',
            id: 'url',
            name: 'url',
            exactFormat: 'url',
            autocompleteValue: 'url',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.GENERAL,
            id: 'contact profile',
            name: 'contact profile',
            exactFormat: 'contactprofile',
            autocompleteValue: 'contactprofile',
            isDisabledInButtons: true
        },
        /*  DISABLED TILL BACKEND FIX:
            {
            group: SpecialFieldGroup.GENERAL,
            displayName: 'Contact profile + ID',
            name: 'contact profile + id',
            additionalValueDescription: t('linkneedscomeexistingsite'),
            additionalValueTitle: 'Publicformid',
            additionalValuePlaceholder: '',
            additionalValueError: 'Invalid id',
            isAdditionalValueRequired: true,
            regexFormat: /^contactprofile:[a-zA-Z]+$/,
            regexKeyword: 'contactprofile',
            autocompleteValue: 'contactprofile',
            isDisabledInButtons: true
        },*/
        {
            group: SpecialFieldGroup.GENERAL,
            id: 'consent',
            name: 'consent',
            exactFormat: 'consent',
            autocompleteValue: 'consent',
            isDisabledInButtons: true
        },
        {
            isUIOnly: true,
            group: SpecialFieldGroup.GENERAL,
            id: 'custom',
            name: 'custom',
            regexKeyword: '',
            additionalValueTitle: t('value'),
            additionalValueError: i18n.t('customfielderror'),
            isAdditionalValueRequired: true,
            requiredText:'',
            regexFormat: new RegExp(`^\{${REGEX_CUSTOM_VALUE}\}$`), //eslint-disable-line no-useless-escape
            additionalValueMaxLength: ADDITIONAL_VALUE_LENGTH,
            getTextValueToInsert: (text: string) => `{${text}}`,
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.GENERAL,
            id: 'consent tracking allow',
            name: 'consent tracking allow',
            exactFormat: 'consenttrackingallow',
            autocompleteValue: 'consenttrackingallow',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.GENERAL,
            id: 'consent tracking deny',
            name: 'consent tracking deny',
            exactFormat: 'consenttrackingdeny',
            autocompleteValue: 'consenttrackingdeny',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.GENERAL,
            displayName: 'Message ID',
            id: 'message id',
            name: 'message id',
            exactFormat: 'msgid',
            autocompleteValue: 'msgid',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.GENERAL,
            id: 'pull content',
            name: 'pull content',
            additionalValueDescription: t('linkneedscomeexistingsite'),
            additionalValueTitle: t('websiteurl'),
            additionalValuePlaceholder: 'https://websiteurl.com',
            additionalValueError: i18n.t('pleaseentervalidurl'),
            isAdditionalValueRequired: true,
            regexFormat: new RegExp(`^pullcontent:${REGEX_URL}$`),
            regexKeyword: 'pullcontent',
            autocompleteValue: 'pullcontent',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.GENERAL,
            id: 'pull content-title',
            name: 'pull content-title',
            additionalValueDescription: t('linkneedscomeexistingsite'),
            additionalValueTitle: t('websiteurl'),
            additionalValuePlaceholder: 'https://websiteurl.com',
            additionalValueError: i18n.t('pleaseentervalidurl'),
            isAdditionalValueRequired: true,
            regexFormat: new RegExp(`^pullcontent-title:${REGEX_URL}$`),
            regexKeyword: 'pullcontent-title',
            autocompleteValue: 'pullcontent-title',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.GENERAL,
            id: 'pull content-rss',
            name: 'pull content-rss',
            additionalValueDescription: t('linkneedscomeexistingsite'),
            additionalValueTitle: t('websiteurl'),
            additionalValuePlaceholder: 'https://websiteurl.com',
            additionalValueError: i18n.t('pleaseentervalidurl'),
            isAdditionalValueRequired: true,
            regexFormat: new RegExp(`^pullcontent-rss:${REGEX_URL}$`),
            regexKeyword: 'pullcontent-rss',
            autocompleteValue: 'pullcontent-rss',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.GENERAL,
            id: 'referrals',
            name: 'referrals',
            exactFormat: 'referrals',
            autocompleteValue: 'referrals',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.GENERAL,
            id: 'unsubscribe',
            name: 'unsubscribe',
            exactFormat: 'unsubscribe',
            autocompleteValue: 'unsubscribe',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.GENERAL,
            displayName: 'Unsubscribe list (mailing preferences)',
            id: 'unsubscribe list',
            name: 'unsubscribe list',
            exactFormat: 'unsubscribelist',
            autocompleteValue: 'unsubscribelist',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.GENERAL,
            id: 'unsubscribe from list',
            name: 'unsubscribe from list',
            exactFormat: 'unsubscribefromlist',
            autocompleteValue: 'unsubscribefromlist',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.GENERAL,
            id: 'view online',
            name: 'view online',
            exactFormat: 'view',
            autocompleteValue: 'view',
            isDisabledInButtons: true
        },

        {
            group: SpecialFieldGroup.CHECKOUT,
            id: 'checkout order number',
            name: 'checkout order number',
            exactFormat: 'checkoutordernumber',
            autocompleteValue: 'checkoutordernumber',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.CHECKOUT,
            id: 'checkout order date',
            name: 'checkout order date',
            exactFormat: 'checkoutorderdate',
            autocompleteValue: 'checkoutorderdate',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.CHECKOUT,
            id: 'checkout product name',
            name: 'checkout product name',
            exactFormat: 'checkoutproductname',
            autocompleteValue: 'checkoutproductname',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.CHECKOUT,
            id: 'checkout product page url',
            name: 'checkout product page url',
            exactFormat: 'checkoutproductpageurl',
            autocompleteValue: 'checkoutproductpageurl',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.CHECKOUT,
            id: 'checkout price',
            name: 'checkout price',
            exactFormat: 'checkoutprice',
            autocompleteValue: 'checkoutprice',
            isDisabledInButtons: true
        },
        {
            group: SpecialFieldGroup.PAID_NEWSLETTER,
            id: 'paid newsletter customer portal',
            name: 'paid newsletter customer portal',
            exactFormat: 'paidnewslettercustomerportal',
            autocompleteValue: 'paidnewslettercustomerportal',
        },
        {
            group: SpecialFieldGroup.PAID_NEWSLETTER,
            id: 'paid newsletter name',
            name: 'paid newsletter name',
            exactFormat: 'paidnewslettername',
            autocompleteValue: 'paidnewslettername',
        },
        {
            group: SpecialFieldGroup.PAID_NEWSLETTER,
            id: 'paid newsletter order date',
            name: 'paid newsletter order date',
            exactFormat: 'paidnewsletterorderdate',
            autocompleteValue: 'paidnewsletterorderdate',
        },
        {
            group: SpecialFieldGroup.PAID_NEWSLETTER,
            id: 'paid newsletter order number',
            name: 'paid newsletter order number',
            exactFormat: 'paidnewsletterordernumber',
            autocompleteValue: 'paidnewsletterordernumber',
        },
        {
            group: SpecialFieldGroup.PAID_NEWSLETTER,
            id: 'paid newsletter product page url',
            name: 'paid newsletter product page url',
            exactFormat: 'paidnewsletterproductpageurl',
            autocompleteValue: 'paidnewsletterproductpageurl',
        },
        {
            group: SpecialFieldGroup.PAID_NEWSLETTER,
            id: 'paid newsletter recurring price',
            name: 'paid newsletter recurring price',
            exactFormat: 'paidnewsletterrecurringprice',
            autocompleteValue: 'paidnewsletterrecurringprice',
        },
    ];
};
